<template>
  <div v-if="whitelabel.omDesign" class="omk-list-select-container">
    <omk-select
      :label="label"
      :value="value"
      :supporting-text="hint"
      :disabled="disabled"
      class="list-select"
      @input="handleInput"
      @change="$emit('change', $event)"
      @blur="$emit('blur', $event)"
      @click="handleClick"
      @focus="$emit('focus', $event)"
      @keypress="$emit('keypress', $event)"
      :custom-validation-message="errors[0]"
    >
      <omk-select-option
        v-for="item in items"
        :key="item.value"
        :value="item.value"
        >{{ item.text }}</omk-select-option
      >
    </omk-select>
  </div>

  <v-select
    v-else
    :value="value"
    :items="items"
    :label="label"
    :error-messages="errors"
    :disabled="disabled"
    @input="handleInput"
    @change="$emit('change', $event)"
    @blur="$emit('blur', $event)"
    @click="handleClick"
    @focus="$emit('focus', $event)"
    @keypress="$emit('keypress', $event)"
  />
</template>

<script>
  export default {
    name: 'ListSelect',
    inheritAttrs: false,
    props: {
      value: {
        type: [String, Number],
        default: '',
      },
      label: {
        type: String,
        default: '',
      },
      placeholder: {
        type: String,
        default: '',
      },
      type: {
        type: String,
        default: 'text',
      },
      prefix: {
        type: String,
        default: '',
      },
      suffix: {
        type: String,
        default: '',
      },
      disabled: {
        type: Boolean,
        default: false,
      },
      readonly: {
        type: Boolean,
        default: false,
      },
      outlined: {
        type: Boolean,
        default: false,
      },
      dense: {
        type: Boolean,
        default: true,
      },
      clearable: {
        type: Boolean,
        default: false,
      },
      required: {
        type: Boolean,
        default: false,
      },
      autocomplete: {
        type: String,
        default: 'off',
      },
      hint: {
        type: String,
        default: '                                           ',
      },
      persistentHint: {
        type: Boolean,
        default: false,
      },
      customClass: {
        type: String,
        default: '',
      },
      name: {
        type: String,
        required: false,
      },
      errors: {
        type: Array,
        default: () => [],
      },
      isDateField: {
        type: Boolean,
        default: false,
      },
      remainderOfEstateMargin: {
        type: Boolean,
        default: false,
      },
      max: {
        type: Number,
        default: null,
      },
      items: {
        type: Array,
        default: () => [],
      },
    },
    methods: {
      handleInput(event) {
        const value = event.target ? event.target.value : event;
        this.$emit('input', value);
      },
      handleClick(event) {
        this.$emit('click', event);
        if (this.isDateField) {
          this.$emit('date-picker-click', event);
        }
      },
    },
  };
</script>

<style lang="scss" scoped>
  .omk-list-select-container {
    z-index: 0;

    .list-select {
      margin-bottom: 24px;
    }
  }
</style>
